import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="subscription-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full"
      >
        <Card className="bg-card border-border">
          <CardContent className="p-10 text-center">
            <div className="w-14 h-14 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-8 h-8 text-muted-foreground" />
            </div>
            <h1 className="font-heading text-2xl font-semibold mb-2">Checkout cancelled</h1>
            <p className="text-muted-foreground mb-8">
              No worries — you can pick a plan whenever you're ready.
            </p>
            <div className="flex flex-col gap-3">
              <Button
                onClick={() => navigate("/paywall")}
                data-testid="back-to-paywall-btn"
                className="w-full bg-primary text-primary-foreground hover:bg-primary/90 py-6"
              >
                Back to plans
              </Button>
              <Button variant="ghost" onClick={() => navigate("/dashboard")}>
                Back to dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default SubscriptionCancel;
